import React, { useRef } from 'react';
import Editor from '@monaco-editor/react';

import {
  Box,
  Button,
  Divider,
  Modal, 
  Typography
} from '@mui/material';

import style from "../../global.scss";
import "./styles.scss";

const CodeViewModal = ({
  open, 
  setOpen,
  title,
  language,
  content
}) => {
  const editorRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
  };

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
    // Auto-format when editor first loads
    editor.getAction('editor.action.formatDocument').run();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"md"} className="modal">
          <Box width={"100%"}
            sx={{ margin: "15px 15px 30px 15px"}}>
            <Typography variant='h6' sx={{ color: style["primary"] }}>
              {title}
            </Typography>
          </Box>
          {
            open
            &&
            <Editor height="80vh" 
              defaultLanguage={language || "javascript"}
              defaultValue={content || "//no content provided"} 
              theme='vs-dark'
              options={{
                wordWrap: true,
                formatOnPaste: true,
                formatOnType: true,
                scrollBeyondLastLine: false,
              }}
              onMount={handleEditorDidMount}
              />
          }
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='outlined'
              onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default CodeViewModal;